// Copied verbatim from eval/dashboard/internal_web/src/components/ui/SearchInput.tsx (ATM-57). Keep in step until ATM-60 shares it.
/**
 * The one text input in the app: the session search above the worklist.
 *
 * Uncontrolled-looking but controlled — the value lives in the URL like every other
 * view state, so a search a reviewer wants to send someone is a link rather than a
 * description of what to type.
 */

import { Search } from "lucide-react";

import { cn } from "../../lib/cn";

type Props = {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  /** Render the label above the field instead of only for screen readers. */
  showLabel?: boolean;
  className?: string;
};

/** A search field. */
export default function SearchInput({
  value,
  onChange,
  label,
  placeholder,
  showLabel = false,
  className,
}: Props) {
  return (
    <div className={cn("flex min-w-0 flex-col gap-1.5", className)}>
      <span className={showLabel ? "text-cell font-medium text-ink-3" : "sr-only"}>{label}</span>
      <div className="control flex h-10 items-center gap-2.5 px-3">
        <Search size={16} className="shrink-0 text-ink-faint" aria-hidden />
        <input
          type="search"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          aria-label={label}
          className="min-w-0 flex-1 bg-transparent text-cell text-ink outline-none"
        />
      </div>
    </div>
  );
}
